/* tslint:disable */
/* eslint-disable */
/**
 * Trendtours CMS API
 * ISO API for the IBE. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiNewsletterSubscriptionRequest
 */
export interface ApiNewsletterSubscriptionRequest {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    additionalProperties?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    salutation?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    birthday?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    nameday?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    hnr?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    locale?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    organization?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    signUpSource?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    thirdPartyConsentEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    externalCustomerId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiNewsletterSubscriptionRequest
     */
    doiKey?: string;
}

export function ApiNewsletterSubscriptionRequestFromJSON(json: any): ApiNewsletterSubscriptionRequest {
    return ApiNewsletterSubscriptionRequestFromJSONTyped(json, false);
}

export function ApiNewsletterSubscriptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiNewsletterSubscriptionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'additionalProperties': !exists(json, 'additionalProperties') ? undefined : json['additionalProperties'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'emailAddress': json['emailAddress'],
        'salutation': !exists(json, 'salutation') ? undefined : json['salutation'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'birthday': !exists(json, 'birthday') ? undefined : json['birthday'],
        'nameday': !exists(json, 'nameday') ? undefined : json['nameday'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'hnr': !exists(json, 'hnr') ? undefined : json['hnr'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'region': !exists(json, 'region') ? undefined : json['region'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'locale': !exists(json, 'locale') ? undefined : json['locale'],
        'organization': !exists(json, 'organization') ? undefined : json['organization'],
        'signUpSource': !exists(json, 'signUpSource') ? undefined : json['signUpSource'],
        'thirdPartyConsentEmail': !exists(json, 'thirdPartyConsentEmail') ? undefined : json['thirdPartyConsentEmail'],
        'externalCustomerId': !exists(json, 'externalCustomerId') ? undefined : json['externalCustomerId'],
        'doiKey': !exists(json, 'doiKey') ? undefined : json['doiKey'],
    };
}

export function ApiNewsletterSubscriptionRequestToJSON(value?: ApiNewsletterSubscriptionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'additionalProperties': value.additionalProperties,
        'title': value.title,
        'emailAddress': value.emailAddress,
        'salutation': value.salutation,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'fullName': value.fullName,
        'gender': value.gender,
        'birthday': value.birthday,
        'nameday': value.nameday,
        'address': value.address,
        'hnr': value.hnr,
        'city': value.city,
        'zip': value.zip,
        'state': value.state,
        'region': value.region,
        'country': value.country,
        'locale': value.locale,
        'organization': value.organization,
        'signUpSource': value.signUpSource,
        'thirdPartyConsentEmail': value.thirdPartyConsentEmail,
        'externalCustomerId': value.externalCustomerId,
        'doiKey': value.doiKey,
    };
}


// custom code here ##################################################################################################################
function toUTC(date) {
  var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
  return new Date(date_utc);
}
